import {
  CALENDAR_LOAD_FAILURE,
  CALENDAR_LOAD_REQUESTED,
  CALENDAR_LOAD_SUCCESS,
  CALENDAR_SHOW_EVENT,
  CALENDAR_HIDE_EVENT,
  CALENDAR_TOGGLE_FULLSCREEN,
  CALENDAR_SEE_EVENT
} from './actions';
import { Event } from '../../models/calendar';
import { SET_DEAL_DATE, RESET_DATA } from '../actions';
import { DEFAULT_TIMEZONE } from '../../services/calendar.service';
import moment from 'moment';
import momentTz from 'moment-timezone';
import { PayloadAction } from '@ipreo/muni-shared';

export interface CalendarState {
  events: Event[];
  eventsDate: Date;
  loading: boolean;
  error?: string;
  selectedEvent?: number;
  fullscreen: boolean;
  mostRecentEventId?: number;
  unseen: boolean;
}

export const calendarDefaultState: CalendarState = {
  events: [],
  eventsDate: new Date(),
  loading: false,
  fullscreen: false,
  unseen: false
};

export function calendarReducer(
  state = calendarDefaultState,
  action: PayloadAction<Event[] | Event | Date | string | number>
): CalendarState {
  let mostRecentEvent;
  switch (action.type) {
    case CALENDAR_LOAD_REQUESTED:
    case SET_DEAL_DATE:
      return {
        ...state,
        events: [],
        eventsDate: (action as PayloadAction<Date>).payload,
        loading: true,
        error: undefined,
        selectedEvent: undefined,
        fullscreen: false,
        mostRecentEventId: undefined,
        unseen: false
      };

    case CALENDAR_LOAD_SUCCESS:
      mostRecentEvent = findMostRecentEvent(
        (action as PayloadAction<Event[]>).payload
      );
      return {
        ...state,
        events: (action as PayloadAction<Event[]>).payload,
        loading: false,
        error: undefined,
        selectedEvent: undefined,
        fullscreen: false,
        mostRecentEventId: mostRecentEvent && mostRecentEvent.id,
        unseen: determineUnseen(state, mostRecentEvent)
      };

    case CALENDAR_LOAD_FAILURE:
      return {
        ...state,
        events: [],
        loading: false,
        error: (action as PayloadAction<string>).payload,
        selectedEvent: undefined,
        fullscreen: false,
        mostRecentEventId: undefined,
        unseen: false
      };

    case CALENDAR_SHOW_EVENT:
      return {
        ...state,
        selectedEvent: (action as PayloadAction<number>).payload
      };

    case CALENDAR_HIDE_EVENT:
      return {
        ...state,
        selectedEvent: undefined,
        fullscreen: false
      };

    case CALENDAR_TOGGLE_FULLSCREEN:
      return {
        ...state,
        fullscreen: !state.fullscreen
      };

    case CALENDAR_SEE_EVENT:
      return {
        ...state,
        unseen: false
      };

    case RESET_DATA:
      return calendarDefaultState;

    default:
      return state;
  }
}

export function findMostRecentEvent(events: Event[]): Event | undefined {
  let event;
  events.forEach((e) => {
    if (!e.nonTimed && moment(e.releasedAt).isBefore(moment())) {
      event = e;
    }
  });
  return event;
}

export function determineUnseen(
  state: CalendarState,
  mostRecentEvent: Event | void
): boolean {
  if (mostRecentEvent) {
    const startOfToday = momentTz().tz(DEFAULT_TIMEZONE).startOf('day');
    const eventIsToday = momentTz(mostRecentEvent.releasedAt)
      .tz(DEFAULT_TIMEZONE)
      .startOf('day')
      .isSame(startOfToday);

    return (
      eventIsToday &&
      (mostRecentEvent.id !== state.mostRecentEventId ||
        (mostRecentEvent.id === state.mostRecentEventId && state.unseen))
    );
  } else {
    return false;
  }
}
